import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const Progress = ({progress}) => {
  return (
    <div style={{ height: "35px", width: "35px" }}>
      <CircularProgressbar value={progress} text={`${progress}%`} 
      strokeWidth={5}
      styles={buildStyles({
        pathColor: "#3684F3",
        pathTransitionDuration: 0.15,
        textSize: "30px"
      })}/>
    </div>
  );
};

export default Progress;
